import {pageInfo, exportData, addData, deleteData, initEdit, editData, importData, downloadTemplate} from './../api';
import { Message } from 'element-ui';
import { areaTree, listCarrier, listCompany, listShipper, listShipType } from '../../../../api'
import {companyListData} from "../../company/api";
const circuit = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    deleteDataObj: null,
    addDataObj: null,
    initEditObj: null,
    editDataObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    companyObj: null,
    areaObj: null,
    shipperObj: null,
    shipTypeObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    INIT_EDIT(state, data) {
      state.initEditObj = data;
    },
    EDIT_DATA(state, data) {
      state.editDataObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
    LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
    LIST_AREA(state, data) {
      state.areaObj = data.obj;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj || {};
    },
    LIST_SHIP_TYPE(state, data) {
      state.shipTypeObj = data.obj;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //添加删除
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //删除数据
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //修改数据
    async initEdit({ commit }, obj) {
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    //修改数据
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({ commit }, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //机构
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
    //承运商
    async listCarrier({ commit }, obj) {
      let resp = await listCarrier(obj);
      commit('LIST_CARRIER', resp);
    },
    //地区
    async listArea({ commit }, obj) {
      let resp = await areaTree(obj);
      commit('LIST_AREA', resp);
    },
    async listShipper({commit}, obj){
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //运输方式
    async listShipType({ commit }, obj) {
      let resp = await listShipType(obj);
      commit('LIST_SHIP_TYPE', resp);
    },

  }
}
export default circuit



// WEBPACK FOOTER //
// ./src/page/mdm/route/store/circuit.store.js